export default "__VITE_ASSET__Bl3YuC$3__"